import styled from "styled-components";

export const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const DropdownTrigger = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.card.border.quaternary || "#D5D7DA"};
  background: #fff;
  color: rgba(10, 13, 18, 0.9);
  font-family: Geist, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  cursor: pointer;
  white-space: nowrap;
  transition: border-color 0.15s ease;

  &:hover {
    border-color: ${({ theme }) => theme.card.hover.primary || "#A4A7AE"};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .trigger-label {
    flex: 1;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .trigger-placeholder {
    color: ${({ theme }) => theme.input.placeholder?.color || "#717680"};
  }

  .trigger-icon {
    flex-shrink: 0;
    transition: transform 0.2s ease;

    &.open {
      transform: rotate(180deg);
    }
  }
`;

export const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 4px;
  padding: 4px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.07);
  border-radius: 8px;
  box-shadow: 0 12px 16px -4px rgba(10, 13, 18, 0.08),
    0 4px 6px -2px rgba(10, 13, 18, 0.03), 0 2px 2px -1px rgba(10, 13, 18, 0.04);
  z-index: 1050;
  display: flex;
  flex-direction: column;
  min-width: ${({ $minWidth }) => $minWidth || "200px"};
  max-height: ${({ $maxHeight }) => $maxHeight || "300px"};
`;

export const MenuItems = styled.div`
  flex: 1;
  overflow-y: auto;
  min-height: 0;
`;

export const SearchInput = styled.div`
  padding: 8px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);

  input {
    width: 100%;
    padding: 6px 10px;
    border: 1px solid
      ${({ theme }) => theme.card.border.quaternary || "#E9EAEB"};
    border-radius: 6px;
    font-size: 13px;
    font-family: Geist, sans-serif;
    line-height: 20px;
    outline: none;
    color: rgba(10, 13, 18, 0.9);

    &::placeholder {
      color: ${({ theme }) => theme.input.placeholder?.color || "#717680"};
    }

    &:focus {
      border-color: ${({ theme }) => theme.card.hover.primary || "#A4A7AE"};
    }
  }
`;

export const MenuItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 6px;
  font-family: Geist, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: rgba(10, 13, 18, 0.9);
  cursor: pointer;
  transition: background-color 0.1s ease;

  &:hover {
    background: rgba(10, 13, 18, 0.04);
  }

  ${({ $isSelected }) =>
    $isSelected &&
    `
    background: rgba(10, 13, 18, 0.03);
  `}

  .item-icon {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      object-fit: cover;
    }
  }

  .item-label {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .item-check {
    flex-shrink: 0;
    color: ${({ theme }) => theme.button.bg?.primary || "#048AF5"};
  }
`;

export const MenuFooter = styled.div`
  padding: 4px;
  border-top: 1px solid rgba(0, 0, 0, 0.07);
  margin-top: 4px;

  button {
    width: 100%;
    padding: 8px;
    border-radius: 6px;
    border: 1px solid rgba(0, 0, 0, 0.07);
    background: #fff;
    font-family: Geist, sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: rgba(10, 13, 18, 0.9);
    cursor: pointer;
    transition: background-color 0.1s ease;

    &:hover {
      background: rgba(10, 13, 18, 0.04);
    }
  }
`;

export const EmptyState = styled.div`
  padding: 16px 8px;
  text-align: center;
  font-family: Geist, sans-serif;
  font-size: 13px;
  line-height: 20px;
  color: ${({ theme }) => theme.input.placeholder?.color || "#717680"};
`;

export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1049;
`;
